import * as actionTypes from "./actionTypes";
import { updateObject } from "../../util/updateObject";
import {
  createMessagiVocaliOrigineDataInitialState,
  currentMessaggiVocaliOrigineInitialState,
} from "./helper";

const initialState = {
  messagiVocaliOrigine: {
    data: [],
    lastUpdated: "",
    loading: false,
  },
  createDeleteLoading: false,
  exportMessaggiVocaliOrigineLoading: false,
  currentMessaggiVocaliOrigine: currentMessaggiVocaliOrigineInitialState,
  createMessaggiVocalieOrigineData: createMessagiVocaliOrigineDataInitialState,
};

const setMessagiVocaliOrigine = (state, action) => {
  return updateObject(state, {
    messagiVocaliOrigine: updateObject(state.messagiVocaliOrigine, {
      [action.key]: action.value,
    }),
  });
};

const setCreateDeleteLoading = (state, action) => {
  return updateObject(state, {
    createDeleteLoading: action.value,
  });
};

const setExportMessaggiVocaliOrigineLoading = (state, action) => {
  return updateObject(state, {
    exportMessaggiVocaliOrigineLoading: action.value,
  });
};

const setCurrentMessaggiVocaliOrigine = (state, action) => {
  return updateObject(state, {
    currentMessaggiVocaliOrigine: updateObject(
      state.currentMessaggiVocaliOrigine,
      {
        [action.key]: action.value,
      }
    ),
  });
};

const setCreateMessaggiVocaliOrigineData = (state, action) => {
  return updateObject(state, {
    createMessaggiVocalieOrigineData: updateObject(
      state.createMessaggiVocalieOrigineData,
      {
        [action.key]: action.value,
      }
    ),
  });
};

const messagiVocaliOrigineReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_MESSAGI_VOCALI_ORIGINE_DATA_AND_LOADING:
      return setMessagiVocaliOrigine(state, action);
    case actionTypes.CREATE_UPDATE_DELETE_MESSAGGI_VOCALI_ORIGINE:
      return setCreateDeleteLoading(state, action);
    case actionTypes.EXPORT_MESSAGGI_VOCALI_ORIGINE_LOADING:
      return setExportMessaggiVocaliOrigineLoading(state, action);
    case actionTypes.GET_MESSAGGI_VOCALI_ORIGINE_BY_ID:
      return setCurrentMessaggiVocaliOrigine(state, action);
    case actionTypes.GET_CREATE_MESSAGGI_VOCALI_ORIGINE_DATA:
      return setCreateMessaggiVocaliOrigineData(state, action);
    default:
      return state;
  }
};

export default messagiVocaliOrigineReducer;
